export const TM_POST_CHANNEL = 'TABLEMANAGER' as const;
export const SUBMIT_TYPE = {
  '대기 서비스 신청': 'waiting',
  '픽업서비스 신청': 'pickup',
  '만족도 조사 서비스 신청': 'survey',
} as const;
